import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './contact-peak/HeroSection';
import { CompanyInfoSection } from './contact-peak/CompanyInfoSection';
import { StaffDirectorySection } from './contact-peak/StaffDirectorySection';
import { ContactFormSection } from './contact-peak/ContactFormSection';
import { CustomerReviewsSection } from './contact-peak/CustomerReviewsSection';
import { BottomCTAsSection } from './contact-peak/BottomCTAsSection';
export function ContactPeakPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1660">
      <SeoBar data-id="element-1661" />
      <Header data-id="element-1662" />
      <main className="flex-grow" data-id="element-1663">
        <div className="w-full bg-gray-50 pb-20" data-id="element-1664">
          <HeroSection data-id="element-1665" />
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12" data-id="element-1666">
            <CompanyInfoSection data-id="element-1667" />
            <div className="grid md:grid-cols-2 gap-8" data-id="element-1668">
              <StaffDirectorySection data-id="element-1669" />
              <ContactFormSection data-id="element-1670" />
            </div>
            <CustomerReviewsSection data-id="element-1671" />
            <BottomCTAsSection data-id="element-1672" />
          </div>
        </div>
      </main>
      <Footer data-id="element-1673" />
    </div>;
}